import React from "react";
import { useSubscription } from "../../context/SubscriptionContext";

const GlobalSubscriptionBanner = () => {
  const { statusText, subscription } = useSubscription();
  const status = subscription?.subscription_status;

  const statusClass =
    status === "active" || status === "trialing"
      ? "bg-green-50 text-green-800 border-green-200"
      : "bg-red-50 text-red-800 border-red-200";

  return (
    <div className={`w-full border rounded-lg px-4 py-3 text-sm font-semibold ${statusClass}`}>
      {statusText}
    </div>
  );
};

export default GlobalSubscriptionBanner;

